import { render, staticRenderFns } from "./LayoutBlank.vue?vue&type=template&id=ca1d9478&scoped=true"
import script from "./LayoutBlank.vue?vue&type=script&lang=js"
export * from "./LayoutBlank.vue?vue&type=script&lang=js"
import style0 from "./LayoutBlank.vue?vue&type=style&index=0&id=ca1d9478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1d9478",
  null
  
)

export default component.exports